import { redirectionApi } from '@services/api';

interface RedirectionRequest {
  redirect_to: string;
  user: number;
  user_uuid: string;
  customer_uuid?: string;
}

const redirection = redirectionApi.injectEndpoints({
  endpoints: (builder) => ({
    redirection: builder.mutation<RedirectionRequest, any>({
      query: (payload) => ({
        url: '',
        method: 'POST',
        body: payload
      })
    })
  })
});

export const { useRedirectionMutation } = redirection;
